import { baseMutations, baseActions } from '../functions'
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    // Info
    items: [],
    title: 'Análises',
    name: 'Análises',
    loading: true,

    // Menu
    menu: {
      title: 'Análises',
      icon: { key: 'tools', custom: true }
    },

    // Routes - Components actions
    actions: {
      // Main Action
      component: 'Cards.Analises', // Alterado para 'Cards.Análises'
      props: { module: 'users', modelKey: 'profile' }
    },

    // Models
    models: {
      profile: [
        { key: 'name', label: 'Nome', slot: 'Nome' }
      ]
    }
  },
  mutations: Object.assign({}, baseMutations, {
    // ...
  }),
  actions: Object.assign({}, baseActions, {
    // ...
    // ...
  })
}
